import { BOX_STATUS, BOX_TYPE_DICT } from "../../constants/boxing";
import {
  ShippingPage,
  PaletizingPage,
  ShipmentOrdersPage,
  OutsideProcessing,
  OutboundOrders,
} from "../../containers";

const includeLocationParam = true;

export const tabs = [
  {
    id: "1",
    label: "Shipments",
    icon: "Tag",
    TabElement: ShipmentOrdersPage,
    includeLocationParam,
    defaultSearchParams: {
      status: [BOX_STATUS.READY].join("-"),
    },
  },
  {
    id: "2",
    label: "Vendor Orders",
    icon: "User",
    TabElement: OutboundOrders,
    includeLocationParam,
  },
  {
    id: "3",
    label: "Vendor Service",
    icon: "Shop",
    TabElement: OutsideProcessing,
    includeLocationParam,
  },
  {
    id: "4",
    label: "Line Items",
    icon: "FileText",
    TabElement: ShippingPage,
    includeLocationParam,
  },
];
